export enum DonateResult {
  Success = 1,
  Fail = 0,
}
